// extracted by mini-css-extract-plugin
module.exports = {"root":"_5VcY5f","closeContainer":"_2fsaVP","closeIcon":"_2czYRD","title":"MQLHBs","container":"_2X_TjG","emptyText":"_3ywfS7","offer":"_2dwPwz"};